import { render, staticRenderFns } from "./InventoryLock.vue?vue&type=template&id=2883ad79"
import script from "./InventoryLock.vue?vue&type=script&lang=js"
export * from "./InventoryLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports